export const GEA_IDS = [49, 50, 51, 52, 53, 54, 55]
export const GIA_IDS = [56, 57, 58, 59, 60, 61, 62]
export const NIA_IDS = [63, 64, 65, 66];
export const EFA_IDS = [67, 68]